/* MIREYA GRACE · Clon estructural — interacciones */
(function () {
  'use strict';

  /* ---------- Utilidades ---------- */
  var money = function (cents) {
    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN', minimumFractionDigits: 2 }).format(cents / 100).replace(/^(\D+)/, '$ ');
    } catch (e) { return '$ ' + (cents / 100).toFixed(2); }
  };
  var onReady = function (fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); };

  /* ---------- Paneles / modales ---------- */
  var lastTrigger = null;
  function openPanel(id, trigger) {
    var p = document.getElementById(id); if (!p) return;
    lastTrigger = trigger || null;
    p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = p.querySelector('input:not([type=hidden]), button:not([data-mgx-close]), a[href]');
    if (f) setTimeout(function () { f.focus(); }, 80);
  }
  function closePanel(p) {
    p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('[data-mgx-panel].is-open')) document.documentElement.style.overflow = '';
    if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
  }
  function movePanelsToBody() {
    document.querySelectorAll('[data-mgx-panel]').forEach(function (p) { if (p.parentElement !== document.body) document.body.appendChild(p); });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-mgx-open]');
    if (o) { e.preventDefault(); openPanel(o.getAttribute('data-mgx-open'), o); return; }
    var c = e.target.closest('[data-mgx-close]');
    if (c) { var p = c.closest('[data-mgx-panel]'); if (p) closePanel(p); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.querySelectorAll('[data-mgx-panel].is-open').forEach(closePanel); });

  /* ---------- Marquee + contador ---------- */
  function initMarquee() {
    document.querySelectorAll('[data-mgx-marquee]').forEach(function (m) {
      var c = m.querySelector('.mgx-marquee__content'); if (!c) return;
      var w = c.getBoundingClientRect().width || 800;
      m.querySelector('.mgx-marquee__track').style.setProperty('--mgx-marquee-duration', Math.max(12, w / 45) + 's');
    });
  }
  function initCountdown() {
    document.querySelectorAll('[data-mgx-countdown]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-end')); if (isNaN(end)) return;
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      function tick() {
        var d = Math.floor((end - Date.now()) / 1000);
        if (d <= 0) { el.hidden = true; clearInterval(t); return; }
        el.hidden = false;
        h.textContent = pad(Math.floor(d / 3600)); m.textContent = pad(Math.floor((d % 3600) / 60)); s.textContent = pad(d % 60);
      }
      var t = setInterval(tick, 1000); tick();
    });
  }

  /* ---------- Swiper ---------- */
  function swiperConfig(type, el) {
    var cfgs = {
      coverflow: {
        effect: 'coverflow', grabCursor: true, centeredSlides: true, slidesPerView: 'auto', loop: true, speed: 600,
        coverflowEffect: { rotate: 0, stretch: 90, depth: 220, modifier: 1, slideShadows: true },
        navigation: { nextEl: el.querySelector('.mgx-colslider__arrow--next'), prevEl: el.querySelector('.mgx-colslider__arrow--prev') },
        autoplay: { delay: 3500, disableOnInteraction: true },
        breakpoints: { 0: { effect: 'slide', slidesPerView: 1, spaceBetween: 0, centeredSlides: false }, 750: { effect: 'coverflow', slidesPerView: 'auto', centeredSlides: true } }
      },
      testimonials: {
        slidesPerView: 'auto', spaceBetween: 20, grabCursor: true,
        navigation: { nextEl: el.parentElement.querySelector('[data-next]'), prevEl: el.parentElement.querySelector('[data-prev]') },
        breakpoints: { 0: { spaceBetween: 12 }, 750: { spaceBetween: 20 } }
      },
      products: {
        slidesPerView: 'auto', spaceBetween: 20, grabCursor: true,
        navigation: { nextEl: el.querySelector('.mgx-related__arrow--next'), prevEl: el.querySelector('.mgx-related__arrow--prev') },
        breakpoints: { 0: { spaceBetween: 12 }, 750: { spaceBetween: 20 } }
      },
      minireviews: { slidesPerView: 1, spaceBetween: 12, loop: true, autoplay: { delay: 4000, disableOnInteraction: false }, speed: 500 }
    };
    return cfgs[type] || {};
  }
  function initSwipers(root) {
    if (!window.Swiper) return;
    (root || document).querySelectorAll('[data-mgx-swiper]').forEach(function (el) {
      if (el.swiper) return;
      var type = 'slide';
      try { type = JSON.parse(el.getAttribute('data-mgx-swiper')).type; } catch (e) {}
      new Swiper(el, swiperConfig(type, el));
    });
  }

  /* ---------- FAQ y desplegables ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-mgx-faq]');
    if (q) {
      var open = q.getAttribute('aria-expanded') === 'true';
      var a = q.nextElementSibling;
      q.setAttribute('aria-expanded', open ? 'false' : 'true');
      a.style.maxHeight = open ? '0px' : a.scrollHeight + 'px';
      return;
    }
    var t = e.target.closest('[data-mgx-collapsible]');
    if (t) {
      var isOpen = t.getAttribute('aria-expanded') === 'true';
      var c = t.nextElementSibling;
      t.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      c.style.maxHeight = isOpen ? '0px' : c.scrollHeight + 'px';
    }
  });

  /* ---------- Estrellas del formulario de reseña ---------- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-mgx-rating] .mgx-rv__star'); if (!s) return;
    var wrap = s.closest('[data-mgx-rating]'); var v = parseInt(s.getAttribute('data-value'), 10);
    wrap.querySelectorAll('.mgx-rv__star').forEach(function (st) { st.classList.toggle('is-on', parseInt(st.getAttribute('data-value'), 10) <= v); });
    wrap.querySelector('input[type=hidden]').value = v;
  });
  function initRatings() { document.querySelectorAll('[data-mgx-rating]').forEach(function (w) { w.querySelectorAll('.mgx-rv__star').forEach(function (st) { st.classList.add('is-on'); }); }); }

  /* ---------- Producto ---------- */
  function initProduct(section) {
    if (!section || section.dataset.mgxReady) return;
    section.dataset.mgxReady = '1';
    var variants = []; try { variants = JSON.parse(section.querySelector('[data-mgx-variants]').textContent); } catch (e) {}
    var meta = {}; try { meta = JSON.parse(section.querySelector('[data-mgx-product-json]').textContent); } catch (e) {}
    var form = section.querySelector('[data-mgx-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]'), compareEl = section.querySelector('[data-compare]'), badgeEl = section.querySelector('[data-badge]');
    var atc = section.querySelector('[data-atc]'), atcLabel = section.querySelector('[data-atc-label]'), errEl = section.querySelector('[data-error]');
    var stockEl = section.querySelector('[data-stock]'), stockCount = section.querySelector('[data-stock-count]');
    var threshold = parseInt(section.getAttribute('data-stock-threshold'), 10) || 10;
    var sticky = document.querySelector('[data-mgx-sticky]');
    var stickySelect = sticky && sticky.querySelector('[data-sticky-select]');
    var stickyPrice = sticky && sticky.querySelector('[data-sticky-price]'), stickyCompare = sticky && sticky.querySelector('[data-sticky-compare]');

    /* Galería */
    var mainEl = section.querySelector('[data-mgx-gallery]'), thumbsEl = section.querySelector('[data-mgx-thumbs]');
    var mainSwiper = null, thumbsSwiper = null;
    if (window.Swiper && mainEl) {
      if (thumbsEl) {
        thumbsSwiper = new Swiper(thumbsEl, { slidesPerView: 'auto', spaceBetween: 8, freeMode: true, watchSlidesProgress: true,
          navigation: { nextEl: section.querySelector('.mgx-pi__thumb-arrow--next'), prevEl: section.querySelector('.mgx-pi__thumb-arrow--prev') } });
      }
      mainSwiper = new Swiper(mainEl, { slidesPerView: 1, spaceBetween: 10, grabCursor: true, thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined });
      section.querySelectorAll('.mgx-pi__thumb').forEach(function (b, i) { b.addEventListener('click', function () { mainSwiper.slideTo(i); }); });
    }
    function showMedia(mediaId) {
      if (!mainSwiper || !mediaId) return;
      var slides = mainEl.querySelectorAll('.swiper-slide');
      for (var i = 0; i < slides.length; i++) { if (slides[i].getAttribute('data-media-id') === String(mediaId)) { mainSwiper.slideTo(i); break; } }
    }

    /* Opciones */
    function selectedOptions() {
      var out = [];
      section.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var ch = fs.querySelector('input:checked'); out.push(ch ? ch.value : null);
      });
      return out;
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function markUnavailable(opts) {
      section.querySelectorAll('[data-option-index]').forEach(function (fs, idx) {
        fs.querySelectorAll('input[data-mgx-option-input]').forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var any = variants.some(function (v) { return v.available && v.options.every(function (o, k) { return k === idx ? o === inp.value : (test[k] === null || o === test[k]); }); });
          inp.classList.toggle('is-unavailable', !any);
        });
        var lbl = fs.querySelector('[data-selected-label]'); var ch = fs.querySelector('input:checked');
        if (lbl && ch) lbl.textContent = '- ' + ch.value;
      });
    }
    function applyVariant(v) {
      if (!v) {
        if (atc) { atc.disabled = true; } if (atcLabel) atcLabel.textContent = 'No disponible';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) { compareEl.hidden = !hasCompare; if (hasCompare) compareEl.textContent = money(v.compare_at_price); }
      if (badgeEl) { badgeEl.hidden = !hasCompare; if (hasCompare) badgeEl.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
      if (atc) { atc.disabled = !v.available; }
      if (atcLabel) atcLabel.textContent = v.available ? (meta.atc || 'Añadir al Carrito') : 'Agotado';
      if (stockEl) {
        var q = (typeof v.inventory_quantity === 'number') ? v.inventory_quantity : null;
        var tracked = v.inventory_management && v.inventory_policy !== 'continue';
        var show = tracked && q !== null && q > 0 && q <= threshold;
        stockEl.hidden = !show; if (show && stockCount) stockCount.textContent = q;
      }
      if (v.featured_media) showMedia(v.featured_media.id);
      if (stickySelect && stickySelect.value !== String(v.id)) stickySelect.value = v.id;
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (stickyCompare) { stickyCompare.hidden = !hasCompare; if (hasCompare) stickyCompare.textContent = money(v.compare_at_price); }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
    }
    section.querySelectorAll('input[data-mgx-option-input]').forEach(function (inp) {
      inp.addEventListener('change', function () { var o = selectedOptions(); markUnavailable(o); applyVariant(findVariant(o)); });
    });
    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        var v = variants.filter(function (x) { return String(x.id) === stickySelect.value; })[0]; if (!v) return;
        section.querySelectorAll('[data-option-index]').forEach(function (fs, idx) {
          var inp = fs.querySelector('input[value="' + CSS.escape(v.options[idx]) + '"]'); if (inp) inp.checked = true;
        });
        markUnavailable(selectedOptions()); applyVariant(v);
      });
    }
    var initial = findVariant(selectedOptions()) || variants[0];
    if (variants.length) { markUnavailable(selectedOptions()); applyVariant(initial); }

    /* Añadir al carrito (abre el carrito lateral del tema) */
    function addToCart() {
      if (!form || !idInput) return;
      if (errEl) errEl.textContent = '';
      atc && atc.classList.add('is-loading');
      var fd = new FormData(); fd.append('id', idInput.value); fd.append('quantity', 1);
      fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', location.pathname);
      fetch((window.routes && routes.cart_add_url) || '/cart/add', { method: 'POST', body: fd, headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { if (errEl) errEl.textContent = res.description || res.message || 'No se pudo añadir el producto.'; return; }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && res.sections) { drawer.renderContents(res); }
          else { location.href = '/cart'; }
        })
        .catch(function () { if (errEl) errEl.textContent = 'Hubo un problema. Inténtalo de nuevo.'; })
        .finally(function () { atc && atc.classList.remove('is-loading'); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    if (sticky) {
      var sb = sticky.querySelector('[data-sticky-atc]'); if (sb) sb.addEventListener('click', addToCart);
      if (atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var visible = entries[0].isIntersecting; var below = entries[0].boundingClientRect.top < 0;
          var show = !visible && below;
          sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        }, { threshold: 0 }).observe(atc);
      }
    }

    /* Fecha estimada de envío (días hábiles) */
    var ship = section.querySelector('[data-mgx-ship]');
    if (ship) {
      var days = parseInt(ship.getAttribute('data-days'), 10) || 2, d = new Date(), added = 0;
      while (added < days) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
      var txt = d.toLocaleDateString('es-MX', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '');
      ship.querySelector('[data-ship-date]').textContent = txt;
    }
  }

  /* ---------- Enlaces heredados a otros dominios ---------- */
  function fixLinks() {
    document.querySelectorAll('a[href*="olivevelvet.com"], a[href*="mireyagrace.com"]').forEach(function (a) {
      var h = a.getAttribute('href').replace(/^https?:\/\/(www\.)?(olivevelvet|mireyagrace)\.com/i, '').replace('/collections/mode-feminine', '/collections/moda-mujer');
      a.setAttribute('href', h || '/');
    });
  }

  function init() {
    movePanelsToBody(); initMarquee(); initCountdown(); initSwipers(); initRatings(); fixLinks();
    document.querySelectorAll('[data-mgx-product]').forEach(initProduct);
  }
  onReady(init);
  window.addEventListener('load', initMarquee);
  document.addEventListener('shopify:section:load', function (e) { movePanelsToBody(); initSwipers(e.target); var p = e.target.querySelector && e.target.querySelector('[data-mgx-product]'); if (p) initProduct(p); initMarquee(); initCountdown(); });
})();
